"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _Text = _interopRequireDefault(require("../Text/Text"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ButtonTab = function ButtonTab(_ref) {
  var selected = _ref.selected,
      icon = _ref.icon,
      iconPosition = _ref.iconPosition,
      children = _ref.children,
      count = _ref.count,
      disabled = _ref.disabled,
      variant = _ref.variant,
      props = _objectWithoutPropertiesLoose(_ref, ["selected", "icon", "iconPosition", "children", "count", "disabled", "variant"]);

  return (0, _themeUi.jsx)("button", _extends({}, props, {
    type: "button",
    disabled: disabled,
    sx: _extends({
      cursor: disabled ? 'default' : 'pointer',
      pointerEvents: disabled ? 'none' : 'auto',
      py: 1,
      position: 'relative',
      variant: "textStyles.caption",
      borderColor: 'primaryLight'
    }, !disabled && {
      ':hover': {
        bg: 'primaryLightHover'
      },
      ':active': {
        bg: 'primaryLightPressed'
      }
    }, {
      ':disabled': {
        color: 'textDisabled',
        borderColor: 'blackDisabled'
      }
    })
  }), (0, _themeUi.jsx)(_themeUi.Flex, {
    sx: {
      flexDirection: iconPosition === 'above' ? 'column' : 'row',
      alignItems: 'center',
      py: 2,
      px: [2, 4],
      color: selected ? 'text' : 'inherit'
    }
  }, icon && (0, _themeUi.jsx)(_Icon["default"], {
    icon: icon,
    size: 2,
    sx: {
      color: 'inherit',
      mr: iconPosition === 'left' ? 1 : 0
    }
  }), children), count && !disabled && (0, _themeUi.jsx)(_themeUi.Box, {
    sx: {
      color: 'white',
      borderRadius: 'large',
      bg: 'alerts.information',
      position: 'absolute',
      height: 1,
      width: 1,
      right: '50%',
      top: 2,
      transform: function transform(theme) {
        return "translateX(" + theme.sizes[4] + "px)";
      }
    }
  }, (0, _themeUi.jsx)(_Text["default"], {
    variant: "display",
    sx: {
      color: 'white'
    }
  }, count >= 100 ? '!' : count)), selected && (0, _themeUi.jsx)("div", {
    sx: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      height: '2px',
      bg: variant === 'primary' ? 'primary' : 'secondary'
    }
  }));
};

ButtonTab.propTypes = {
  selected: _propTypes["default"].bool,
  count: _propTypes["default"].number,
  icon: _propTypes["default"].func,
  iconPosition: _propTypes["default"].oneOf(['above', 'left']),
  variant: _propTypes["default"].oneOf(['primary', 'secondary']),
  disabled: _propTypes["default"].bool,
  children: _propTypes["default"].node
};
ButtonTab.defaultProps = {
  selected: false,
  icon: null,
  iconPosition: 'above',
  count: null,
  variant: 'primary',
  disabled: false,
  children: null
};
var _default = ButtonTab;
exports["default"] = _default;